import { commitMutation, graphql } from 'react-relay';
import environment from '../../../environment';

const mutation = graphql`
  mutation removeSelectedFrontSquareBoxByGuestMutation(
    $input: remove_selected_front_square_box_by_guest_mutationInput!
  ) {
    removeSelectedFrontSquareBoxByGuest(input: $input) {
      code
      message
    }
  }
`;

function removeSelectedFrontSquareBoxByGuest(data, callback) {
  const variables = {
    input: data,
  };

  commitMutation(environment, {
    mutation,
    variables,
    onCompleted: (response, errors) => {
      callback(response);
    },
    onError: err => console.error(err),
  });
}

export default removeSelectedFrontSquareBoxByGuest;
